import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, MapPin } from 'lucide-react';
import { packages } from '../mock';
import { slugify } from '../data';
import { SectionHead } from './Destinations';

export default function Packages() {
  return (
    <section id="packages" className="py-20 md:py-28 bg-[#f6f8fb]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHead
          eyebrow="CURATED HOLIDAYS"
          title="Handpicked Holiday Packages."
          sub="Carefully designed itineraries combining the best experiences, comfortable stays and seamless travel planning."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <div
              key={p.title}
              className="group bg-white rounded-2xl overflow-hidden reveal shadow-[0_14px_34px_rgba(11,37,69,0.08)] hover:shadow-[0_22px_50px_rgba(11,37,69,0.16)] hover:-translate-y-1.5 transition-all duration-300"
              style={{ transitionDelay: `${(i % 3) * 80}ms` }}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={p.img} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-white/95 text-[#0B2545] text-xs font-semibold flex items-center gap-1">
                  <Clock size={13} className="text-[#EA5019]" /> {p.duration}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-xl font-bold text-[#0B2545]">{p.title}</h3>
                <p className="mt-1.5 text-sm text-slate-500 flex items-center gap-1.5"><MapPin size={14} className="text-[#EA5019]" /> {p.places}</p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs text-slate-400">Starts from</p>
                    <p className="font-heading text-lg font-extrabold text-[#0B2545]">{p.price}</p>
                  </div>
                  <Link to={`/packages/${slugify(p.title)}`} className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-[#0B2545] text-white text-sm font-semibold hover:bg-[#EA5019] transition-colors">
                    Explore <ArrowRight size={15} />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
